// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3eZoi","select":"Header_select__3a3Zw","clinic":"Header_clinic__1aHPw"};